import { render, staticRenderFns } from "./UserbookOverview.vue?vue&type=template&id=6eddac8b&scoped=true"
import script from "./UserbookOverview.vue?vue&type=script&lang=js"
export * from "./UserbookOverview.vue?vue&type=script&lang=js"
import style0 from "./UserbookOverview.vue?vue&type=style&index=0&id=6eddac8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eddac8b",
  null
  
)

export default component.exports